export default "__VITE_ASSET__CqTv2ckq__"